import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import { createRoot } from 'react-dom/client';

const dateNow = new Date();
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
        <footer className="App-footer container">
            <p>© {dateNow.getFullYear()} NutriCherry LTD / TheCodersCorner.com. Application version {process.env.REACT_APP_VERSION} </p>
            <p><a href="https://www.nutricherry.com/legal/privacy">Privacy policy and terms of use</a></p>
        </footer>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(() => {});
